module.exports = __webpack_public_path__ + "static/media/event3.0dd4b2f8.jpeg";